import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable()
export class VideoService {

    constructor(private http: HttpClient) {
    }

    videos = [];

    getVideos() {
        let url = `${environment.apiUrl}appvideo/?app=27&limit=1000`;
        let promise = this.http.get(url).toPromise();

        promise.then(data => {
            this.videos = data['objects'];
        });
        return promise;
    }

    getVideo(id) {
        return new Promise((resolve, reject) => {
            this.getVideos().then(data => {
                let foundIndex = this.videos.findIndex(x => x.id === parseInt(id));
                resolve(this.videos[foundIndex])
            });
        });
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/shared/video.service.ts